import { render, staticRenderFns } from "./gen5.vue?vue&type=template&id=418eccb2&scoped=true"
import script from "./gen5.vue?vue&type=script&lang=js"
export * from "./gen5.vue?vue&type=script&lang=js"
import style0 from "./gen5.vue?vue&type=style&index=0&id=418eccb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418eccb2",
  null
  
)

export default component.exports